const messages = {
  dashboard: {
    title: "Dashboard commerciale",
    description:
      "Benvenuto nella tua dashboard. Qui puoi vedere i dati attuali e le aziende partecipanti della tua clientela.",
    overview: {
      title: "Panoramica clienti partecipanti",
      description:
        'Aziende registrate su BRIDGESTONE <span class="text-danger">PLUS</span> con un numero cliente che possiamo associare a te.',
      month: "Nuovi questo mese",
      year: "Nuovi quest'anno",
      all: "Totale",
    },
    credits: {
      title: "Accrediti punti",
      description:
        "Punti premio assegnati alle aziende partecipanti sulla base dei dati di vendita comunicati.",
      month: "Mese corrente",
      year: "Anno in corso",
      prev_year: "Anno precedente",
      allDealers: "Tutti i punti rivenditori",
      allPoints: "Tutti i punti",
      prev_month: "Mese precedente",
      tenant: {
        de_ch: {
          title: "Accrediti punti",
          description:
            "Punti premio assegnati alle aziende partecipanti sulla base dei dati di vendita comunicati.",
          prev_month: "Mese precedente",
          month: "Mese corrente",
          prev_year: "Anno precedente",
          allPoints: "Tutti i punti",
          allDealers: "Tutti i punti rivenditori",
        },
        nl: {
          title: "Panoramica punti marketing",
          description:
            "I punti marketing vengono assegnati alle aziende partecipanti sulla base dei dati di vendita inviati.",
          prev_month: "Mese precedente",
          month: "Mese corrente",
          year: "Totale accumulato nell'anno corrente",
          prev_year: "Totale accumulato nell'anno precedente",
        },
      },
    },
    details: {
      title: "Clienti partecipanti nel dettaglio",
      description:
        'Di seguito sono elencate le aziende registrate su BRIDGESTONE <span class="text-danger">PLUS</span> con un numero cliente assegnato a te come referente. Usa i filtri di ordinamento o la ricerca per trovare clienti specifici.<br/><br/> <b>Nota:</b> cliccando sul saldo punti accedi al dettaglio estratto conto.',
    },
    lastImport:
      'Ultimo import dei dati di vendita: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Alle aziende partecipanti vengono accreditate le commissioni kickback in base ai dati di vendita trasmessi.",
    },
    tyres: {
      title: "Reifen",
      description: "Pneumatici acquistati dai partecipanti al programma",
    },
    short:
      "Benvenuto nella tua dashboard. Qui puoi vedere dati aggiornati e aziende partecipanti del tuo portafoglio clienti.",
    headers: {
      city: "Città",
      company: "Azienda",
      current_points: "Punti attuali",
      customer_number: "Numero cliente",
      details: "Dettagli",
      last_login: "Ultimo accesso",
      name: "Nome",
      postal_code: "CAP",
      street: "Indirizzo",
      email: "Email",
    },
    reload: "Ricarica",
    exports: {
      title: "File Excel esportati",
      downloadExcel: "Scarica Excel",
      running: "In esecuzione",
      head: {
        name: "Nome",
        status: "Stato",
      },
    },
  },
};
export default {
  messages,
};
